import React, { useState } from "react";
import "./Portfolio.css";

const projects = [
  {
    title: "Genesis Poweronics",
    category: "SEO",
    image: "/images/genesis.png",
    description:
      "Strategic SEO optimization and full-scale digital marketing campaign resulting in dominant search presence.",
    services: ["🔍 SEO", "📈 Google Ads", "✍️ Content"],
    results: ["+120% Traffic", "3x Leads", "#1 Ranking"],
    link: "https://genesispoweronics.com"
  },
  {
    title: "Shiri Infra",
    category: "Social",
    image: "/images/shiriinfra.png",
    description:
      "A holistic digital strategy focusing on high-engagement social media management and conversion-led web optimization.",
    services: ["📱 Social", "🔍 SEO", "⚡ Strategy"],
    results: ["+80% Engagement", "2x Conversions"],
    link: "https://srihiinfra.com/"
  },
  {
    title: "GenServices AI",
    category: "PPC",
    image: "/images/genservice.png",
    description:
      "Aggressive brand visibility campaign leveraging performance marketing and advanced SEO analytics.",
    services: ["🔍 SEO", "⚡ Performance", "📊 Analytics"],
    results: ["+200% Visibility", "50% Lower CPC"],
    link: "https://genserviceal.com/"
  },
  {
    title: "Nuts By",
    category: "E-commerce",
    image: "/images/nutsby.png",
    description:
      "E-commerce hyper-growth strategy utilizing precision-targeted paid campaigns and UX optimization.",
    services: ["🛒 E-commerce", "📈 Google Ads", "💎 Luxury"],
    results: ["+300% Sales", "ROAS 5.2x"],
    link: "#"
  }
];

const categories = ["All", "SEO", "PPC", "Social", "E-commerce"];

function Portfolio() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredProjects = activeCategory === "All" 
    ? projects 
    : projects.filter(p => p.category === activeCategory);

  return (
    <section className="portfolio" id="portfolio">
      <div className="portfolio-header" data-aos="fade-up">
        <span className="accent-tag">Our Work</span>
        <h2>Success <span className="highlight">Stories</span></h2>
        <p className="portfolio-subtitle">
          Explore how we help brands scale through data-driven performance and creative excellence.
        </p>

        {/* Filter Bar */}
        <div className="filter-bar">
          {categories.map((cat) => (
            <button 
              key={cat}
              className={`filter-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      <div className="portfolio-container">
        {filteredProjects.map((project, index) => (
          <div
            className="portfolio-card"
            key={`${project.title}-${activeCategory}`}
            data-aos="zoom-in-up"
          >
            <div className="portfolio-image">
              <img src={project.image} alt={project.title} />
              <div className="portfolio-overlay">
                <a href={project.link} target="_blank" rel="noopener noreferrer">
                  Interactive Reveal →
                </a>
              </div>
            </div>
            <div className="portfolio-details">
              <div className="details-top">
                <span className="project-category">{project.category}</span>
                <h3>{project.title}</h3>
              </div>
              <p>{project.description}</p>

              {/* Services & Results Groups */}
              <div className="meta-groups">
                <div className="meta-group">
                  <h4>Capabilities</h4>
                  <div className="tags">
                    {project.services.map((service, i) => (
                      <span key={i} className="tag">{service}</span>
                    ))}
                  </div>
                </div>

                <div className="meta-group">
                  <h4>Success ROI</h4>
                  <div className="results">
                    {project.results.map((result, i) => (
                      <div key={i} className="result-card">{result}</div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Portfolio;